import * as yup from "yup";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useContext, useEffect, useState } from 'react';
import { Stack, Grid, Typography, Button, Box, Link } from '@mui/material';
import { MyAutocomplete, SelectPopup } from '../../../component/index';
import { generateCodeChallenge } from "../../help/generate";
import CancelIcon from '@mui/icons-material/Cancel';
import FolderStructure from "../../foloder-structure";
import DataSourceMngContext from "../../../context/DataSourceMngContext";
import { GradienCheckCircleIcon, GradienWarningIcon, GradienBlockIconIcon } from "../../../component/icons/icon-gradient";

const schema = yup.object().shape({
  fields: yup.array().of(
    yup.object().shape({
      building: yup.object().required("กรุณาเลือกอาคาร"),
      input_type: yup.object().required("กรุณาเลือกประเภทข้อมูล"),
      directory: yup.object().required("กรุณาเลือกโฟลเดอร์"),
    }))
});

export const handleSignInOnedrive = async () => {
  const clientId = '6ad22b99-008d-4590-bcac-1c4436eb3e32';
  const redirectUri = window.location.href;
  const responseType = 'code';
  const scope = 'openid profile User.Read';
  const state = '12345';

  // รอการสร้าง code_challenge
  const { codeChallenge } = await generateCodeChallenge();

  // สร้าง URL สำหรับการเข้าสู่ระบบ Microsoft
  const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=${responseType}&redirect_uri=${encodeURIComponent(redirectUri)}&response_mode=query&scope=${encodeURIComponent(scope)}&state=${state}&code_challenge_method=S256&code_challenge=${codeChallenge}&prompt=select_account`;

  // เปลี่ยนหน้าไปยัง URL ของ Microsoft
  window.location.href = authUrl;
};

export function ContentsOnedrive() {

  const [isSave, setIsSave] = useState(false);
  const { buildings, input_types, folders, setup_details, loading, setDataState, setLoading, setDialog, Add_Server, Remove_Config, fetchBuilding, fetchInputType, fetchDirectory, fetchConfigure, fetchDataSource } = useContext(DataSourceMngContext);

  const { control, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      fields: setup_details?.results,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "fields",
  });

  // ดึงข้อมูลจาก API เมื่อคอมโพเนนต์ถูก mount
  useEffect(() => {
    setValue("fields", setup_details?.results); // กำหนดค่าให้ฟอร์ม
  }, [setup_details?.results, setValue]);

  const handleClose = () => {
    fetchDataSource();
    setDialog('add_server', false);
    setDataState((s) => ({
      ...s,
      selectServer: null,
    }));
  };

  const handleEdit = () => {
    fetchConfigure();
    setIsSave(false);
  }

  const onSubmit = (data) => {
    if (data?.fields?.length === 0) return;
    setLoading('modal', true);
    Add_Server(data?.fields?.map((item, idx) => {
      return {
        id: item?.id || null,
        uid: fields?.find((f, i) => i === idx)?.id,
        building: item?.building?.id,
        input_type: item?.input_type?.id,
        dir_id: item?.directory?.directory_id || item?.directory?.id,
        dir_name: item?.directory?.name || item?.directory?.display,
      }
    }));
    setIsSave(true);
  };

  const handleAddItem = () => {
    append({ building: null, input_type: null, directory: null, active: true });
  }

  const ComfirmRemove = (id) => {
    const index = fields?.findIndex((item) => item.id === id);
    remove(index);
    Remove_Config(setup_details?.results[index]?.id);
    setDataState((s) => ({
      ...s,
      loading: {
        ...s.loading,
        modal: true
      }
    }));
  };

  const handleRemove = (id) => {
    setDataState((s) => ({
      ...s,
      warning: {
        ...s.warning,
        open: true,
        severity: "warning",
        okBtnText: "Yes, Delete",
        cancelBtnText: "Cancel",
        warningTitle: "Are you sure you want to delete?",
        handleOkClicked: () => ComfirmRemove(id),
      }
    }));
  };

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={2}>
        <Typography>
          You are now syncing with OneDrive
        </Typography>
        {fields?.length > 0 && fields.map((item, index) => (
          <Grid container key={item?.id} sx={{ position: "relative", border: StatusCreate(item?.status)?.border, borderRadius: '12px', padding: '20px 5px 15px 5px' }}>
            <Grid item xs={4} sx={{ padding: '0px 5px' }}>
              <Controller
                name={`fields.${index}.building`}
                control={control}
                render={({ field }) => (
                  <MyAutocomplete
                    field={field}
                    placeholder="Building"
                    options={buildings}
                    disabled={isSave}
                    defaultValue={field?.value}
                    error={!!errors.fields?.[index]?.building}
                    helperText={errors.fields?.[index]?.building?.message}
                    getOptionLabel={(option) => option.name || option.display}
                    onFocus={() => fetchBuilding()}
                    onChange={(event, newValuel) => field.onChange(newValuel)}
                  />
                )

                }
              />
            </Grid>
            <Grid item xs={4} sx={{ padding: '0px 5px' }}>
              <Controller
                name={`fields.${index}.input_type`}
                control={control}
                render={({ field }) => (
                  <MyAutocomplete
                    field={field}
                    placeholder="Input Type"
                    options={input_types}
                    disabled={isSave}
                    error={!!errors.fields?.[index]?.input_type}
                    helperText={errors.fields?.[index]?.input_type?.message}
                    getOptionLabel={(option) => option.display || option.name}
                    onFocus={() => fetchInputType()}
                    onChange={(event, newValuel) => field.onChange(newValuel)}
                  />
                )}
              />
            </Grid>
            <Grid item xs={4} sx={{ padding: '0px 5px' }}>
              <Controller
                name={`fields.${index}.directory`}
                control={control}
                render={({ field }) => (
                  <SelectPopup placeholder="Directory"
                    value={field?.value?.name || field?.value?.display}
                    disabled={isSave}
                    loading={loading?.folder}
                    errors={item?.status === 'NOT_FOUND' ? {
                      "message": "This directory is not found!",
                      "type": "nullable",
                      "ref": {
                        "name": `fields.${index}.directory`
                      }
                    } : errors.fields?.[index]?.directory}
                    onChange={(value) => field.onChange(value)}
                    onFocus={fetchDirectory}>
                    <FolderStructure
                      folders={folders}
                      folder={field}
                      fetchFolder={fetchDirectory}
                      onSelect={(f) => field.onChange(f)}
                    />
                  </SelectPopup>
                )}
              />
            </Grid>
            {isSave ?
              <Box
                sx={{ position: 'absolute', top: 0, left: 0, padding: '10px 10px', width: '100%', display: 'flex', justifyContent: 'end', fontSize: '10px' }}>
                {StatusCreate(item?.status)?.ui}
              </Box> :
              <Box
                sx={{ position: 'absolute', top: 0, left: 0, padding: '10px 10px', width: '100%', display: 'flex', justifyContent: 'end' }}>
                <CancelIcon color="error" fontSize="small" sx={{ cursor: 'pointer' }} onClick={() => handleRemove(item?.id)} />
              </Box>
            }
          </Grid>
        ))}
      </Stack >
      <Box
        sx={{
          position: 'absolute',
          bottom: 0, left: 0,
          padding: '10px 20px',
          width: '100%',
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'space-between'
        }}>
        {setup_details?.results?.isErr ?
          <Stack direction="row" spacing={0.5}>
            <GradienWarningIcon fontSize={20} />
            <Typography sx={{ fontSize: '13px', color: '#ef6c00' }}>*** กรอกข้อมูลซ้ำ</Typography>
          </Stack>
          : isSave ?
            <Link
              component="button"
              variant="body2"
              color="primary"
              onClick={handleEdit}>
              {`<-- Edit`}
            </Link>
            :
            <Typography sx={{ fontSize: '13px', color: 'red' }}>*** ข้อมูลจะถูก sync อัตโนมัติในทุกวัน</Typography>
        }
        <Stack direction="row" spacing={0.5}>
          {!isSave &&
            <Button
              variant="outlined"
              size='small'
              onClick={handleAddItem}>+ Add</Button>
          }
          <Button variant="outlined" size='small' onClick={handleClose}>
            Cancel
          </Button>
          {!isSave &&
            <Button type="submit" variant="contained" size='small'>
              Save
            </Button>
          }
        </Stack>
      </Box>
    </Box>
  );
};

function StatusCreate(status) {
  switch (status) {
    case 'CREATED':
    case 'CREARED':
      return {
        border: '1px solid #43a047',
        ui: <Stack direction="row" spacing={0.5}><GradienCheckCircleIcon fontSize={15} /><p>Created!</p></Stack>
      };
    case 'UPDATED':
      return {
        border: '1px solid #039be5',
        ui: <Stack direction="row" spacing={0.5}><GradienCheckCircleIcon fontSize={15} /><p>Updated!</p></Stack>
      };
    case 'DUPLICATED':
      return {
        border: '1px solid #fb8c00',
        ui: <Stack direction="row" spacing={0.5}><GradienWarningIcon fontSize={15} /><p>Duplicate!</p></Stack>
      };
    case 'NOT_FOUND':
      return {
        border: '1px solid #e53935',
        ui: <Stack direction="row" spacing={0.5}><GradienBlockIconIcon fontSize={15} /><p>Not found!</p></Stack>
      };
    case null:
    case undefined:
      return {
        border: '1px solid #e0e0e0',
        ui: null
      };
    default:
      return {};
  }
}